import { useCallback } from 'react';
import { prop } from 'ramda';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchFreeSpinDetails = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const translate = useComponentTranslations();
    const bonusDetails = useDynamicReducerSelector(prop('bonusDetails'));

    return useCallback((id) => {
        if (!isMounted() || bonusDetails[id] && !bonusDetails[id].error) {
            return;
        }

        dispatch(actions.setBonusDetails({ id, isLoading: true, error: '' }));

        (async () => {
            try {
                const { data } = await server.getBonusDetails(id);
                isMounted() && dispatch(
                    actions.setBonusDetails({
                        id,
                        bonusDetails: data,
                        isLoading: false,
                        error: ''
                    })
                );

            } catch (error) {
                isMounted() && dispatch(
                    actions.setBonusDetails({
                        id,
                        isLoading: false,
                        error: translate('error')
                    })
                );
            }
        })();

    }, [isMounted, dispatch, translate, bonusDetails]);
};
